/* eslint-disable camelcase */

export const DocumentStatus = {
  PUBLISHED: 'PUBLISHED',
  DRAFT: 'DRAFT',
  DRAFT_READY: 'DRAFT_READY',
  PENDING_QC: 'PENDING_QC',
  INTERNAL_REJECTED: 'INTERNAL_REJECTED',
  INITIAL_CHECK: 'INITIAL_CHECK',
} as const;

export const DocumentTypeLabels = {
  'DOCTYPE.RADIOLOGY.REPORT': 'Radiology',
  'DOCTYPE.BODY.COMPOSITION': 'Body Composition',
  'DOCTYPE.BLOOD.REPORT': 'Blood Test',
  'DOCTYPE.ADVANCE.NEURO': 'Brain Health Assessment',
  'DOCTYPE.ADVANCE.HEART': 'Heart Health Assessment',
} as const;

export const DocumentErrorCode = {
  CREATE_NO_PERMISSION: 'API.ERROR.DOCUMENT.CREATE.NO_PERMISSION',
  READ_NO_PERMISSION: 'API.ERROR.DOCUMENT.READ.NO_PERMISSION',
  DEACTIVATE_NO_PERMISSION: 'API.ERROR.DOCUMENT.DEACTIVATE.NO_PERMISSION',
  DOCUMENT_NAME_ALREADY_EXISTS: 'API.ERROR.DOCUMENT.CREATE.NAME_ALREADY_EXISTS',
  RIS_LOOKUP_FAILED: 'API.ERROR.DOCUMENT.CREATE.RIS_LOOKUP_FAILED',
  RIS_INTEGRATION_FAILED: 'API.ERROR.DOCUMENT.CREATE.RIS_INTEGRATION_FAILED',
} as const;

export const DOCUMENT_ERROR_MESSAGES = {
  [DocumentErrorCode.CREATE_NO_PERMISSION]:
    "You don't have sufficient permissions for this operation",
  [DocumentErrorCode.READ_NO_PERMISSION]:
    "You don't have sufficient permissions for this operation",
  [DocumentErrorCode.DEACTIVATE_NO_PERMISSION]:
    "You don't have sufficient permissions for this operation",
  [DocumentErrorCode.DOCUMENT_NAME_ALREADY_EXISTS]:
    'Document name is already used for another type. Please use a different name and try again.',
  [DocumentErrorCode.RIS_LOOKUP_FAILED]:
    'Unable to fetch care plan and activity IDs from RIS. Please ensure the study has valid care plan and care activity information.',
  [DocumentErrorCode.RIS_INTEGRATION_FAILED]:
    'Unable to fetch care plan and activity IDs from RIS. Please ensure the study has valid care plan and care activity information.',
} as const;

export const DEFAULT_ERROR_MESSAGE =
  'Operation failed. Please try again. Report if issue persists.';
